import React from 'react'
import { Table } from 'reactstrap';

export default class Mytable extends React.Component{
    render(){
        const { caption, data } = this.props;
        return (
            <Table bordered style={{backgroundColor: 'rgba(0,0,0, .6)'}}>
              <thead>
                <tr>
                  <th colSpan="2">{ caption }</th>
                </tr>
              </thead>
              <tbody>
                    {
                        data.map((row, index) => (
                            <tr key={index}>
                                <td>{ row.info1}</td>
                                <td>{ row.info2} </td>
                            </tr>
                        ))
                    }
              </tbody>
            </Table>
        )
    }
}